module.exports = __webpack_public_path__ + "img/6.696ff05.jpg";